'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _baseForm = require('common/components/base-form');

var _baseForm2 = _interopRequireDefault(_baseForm);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _hfReactHelper = require('common/utils/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

var _button = require('common/components/button');

var _button2 = _interopRequireDefault(_button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var LogInInPerson = _baseForm2['default'].createFormClass({

    propTypes: {
        'guid': _react2['default'].PropTypes.string.isRequired,
        'title': _react2['default'].PropTypes.string.isRequired
    },

    onEmailChange: function onEmailChange(event) {
        this.setState({
            'emailAddress': event.target.value.trim()
        });
    },

    onSubmit: function onSubmit(e) {
        e.preventDefault();

        var emailAddress = $('#email_address').val();

        if (!_hfReactHelper2['default'].isValidEmailAddress(emailAddress)) {
            this.setState({
                'errors': { 'named': { 'email_address': 'Invalid email address' } }
            });
        } else {
            $('#login-form').submit();
        }
    },

    render: function render() {
        var errors = '';
        if (this.state.errors) {
            errors = _jsx('div', {
                className: 'row'
            }, void 0, _jsx('div', {
                className: 'columns small-12 text-center m-login-in-person--errors'
            }, void 0, this.renderErrorText()));
        }
        return _jsx('div', {
            className: 'm-login-in-person row'
        }, void 0, _jsx('h4', {}, void 0, this.props.title), _jsx('div', {}, void 0, 'To review this document'), _jsx('form', {
            id: 'login-form',
            className: 'm-login-in-person--form',
            action: _hfReactHelper2['default'].urlHelper('signer/signInPerson'),
            method: 'POST'
        }, void 0, this.renderField('email_address', {
            'id': 'email_address',
            'className': '',
            'maxLength': '99',
            'placeholder': 'Enter your email',
            'onChange': this.onEmailChange,
            'tabIndex': '0',
            'data-format': 'email'
        }), _jsx('div', {
            className: 'row'
        }, void 0, _jsx('div', {
            className: 'columns small-12'
        }, void 0, _jsx(_button2['default'], {
            onClick: this.onSubmit,
            buttonClass: 'right',
            buttonText: 'Continue',
            buttonColor: 'cerulean',
            buttonHoverColor: 'castle-rock',
            buttonTabIndex: '1'
        }))), _jsx('input', {
            type: 'hidden',
            name: 'short_guid',
            value: this.props.guid
        })), errors);
    }
});

module.exports = LogInInPerson;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/auth/login-in-person.jsx
 ** module id = 762
 ** module chunks = 0
 **/